import DocumentationButton from "components/DocumentationButton";
import {
  EmptystateCodeBrowserColored,
  EmptystateSearchNoResultsColored,
} from "components/icons/generated";
import Box from "ds/components/Box";
import Button from "ds/components/Button";
import EmptyState from "ds/components/EmptyState";
import { getDocsUrl } from "utils/getDocsUrl";
import useTypedContext from "hooks/useTypedContext";

import TemplateFeatureGateTooltip from "../../TemplatesWorkbench/FeatureGate/Tooltip";
import { TemplateActions } from "../../TemplatesWorkbench/FeatureGate/types";
import { TemplateContext } from "../Context";

type TemplateVersionsEmptyProps = {
  hasNoResults?: boolean;
  onCreate: () => void;
};

const TemplateVersionsEmpty = ({ hasNoResults, onCreate }: TemplateVersionsEmptyProps) => {
  const { template } = useTypedContext(TemplateContext);

  return (
    <>
      {hasNoResults && (
        <EmptyState
          title="No results"
          caption="Try different filters."
          icon={EmptystateSearchNoResultsColored}
          announce
        />
      )}

      {!hasNoResults && (
        <EmptyState title="You don’t have any versions yet" icon={EmptystateCodeBrowserColored}>
          <Box gap="medium">
            <DocumentationButton
              to={getDocsUrl("/concepts/template/workbench#managing-template-versions")}
              label="Documentation"
            />
            <TemplateFeatureGateTooltip
              action={TemplateActions.EditTemplate}
              template={template}
              on={({ isDisabled, ...props }) => (
                <Button {...props} variant="primary" onPress={onCreate} disabled={isDisabled}>
                  Create version
                </Button>
              )}
            />
          </Box>
        </EmptyState>
      )}
    </>
  );
};

export default TemplateVersionsEmpty;
